import React from "react";
import { useDispatch } from "react-redux";
import { Modal, Header, Message } from "semantic-ui-react";
import { closeModal, clearError } from "../actions";

const ErrorModal = (props) => {
  const dispatch = useDispatch();

  const { error, type } = props;

  return (
    <Modal
      closeIcon="close"
      open={true}
      onClose={() => {
        dispatch(closeModal());
        dispatch(clearError());
      }}
      size={error.size}
      {...props}
    >
      <Modal.Content>
        <Header as="h3">{error.name}</Header>
        <Message className={type}>
          <p>{error.error}</p>
          {error.reason && <p>{error.reason}</p>}
        </Message>
      </Modal.Content>
    </Modal>
  );
};

export default ErrorModal;
